import request from '@/utils/request';

// 查询操作日志
export function queryOperationLogApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/ydBatchOpt/queryAddYdList',
    method: 'post',
    data
  });
}
// 导出操作日志
export function exportOperationLogApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/ydBatchOpt/exportAddYdList',
    method: 'post',
    data,
    responseType: 'blob'
  });
}
// 根据用户Id查用户电话
export function getUserMobileByLoginIdApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/users/getUserMobileByLoginId',
    method: 'post',
    data
  });
}
